import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { ChevronDown } from "lucide-react";

export const FAQ: React.FC<{
  question: string;
  answer: string | React.ReactNode;
}> = ({ question, answer }) => {
  return (
    <Accordion
      variant="borderless"
      sx={{
        margin: "0 !important",
        padding: "0 !important",
        width: "100%",
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary
        expandIcon={<ChevronDown />}
        sx={{ ".MuiAccordionSummary-content": { marginTop: "8px !important" } }}
      >
        <Typography variant="bodyHeavy">{question}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="bodySmall">{answer}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};
